import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'validation-message',
    template: `<p
    class="ir-required th-required"
    [class.visible]="
      validationControl.hasError(validationName) &&
      (validationControl.touched || validationControl.dirty || validationControl.pristine) &&
      validationControl.invalid
    "
  >
    <span>{{ errorMessage }}</span>
  </p>`,
    standalone: false
})
export class ValidationMessageComponent {
  @Input() validationControl: AbstractControl;
  @Input() validationName: string = '';
  @Input() errorMessage: string = '';
}
